import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';
import { ListingImage } from '../elements-image/listing-image';

const EventDetailCard = ({
  booking = {},
  listingImageExternalId = '',
  guestFirstName = ''
}) => {
  const startDate = get(booking, 'start.date', {});
  const endDate = get(booking, 'end.date', {});
  const momentStart = moment(`${startDate.y}-${startDate.m}-${startDate.d}`, 'YYYY-MM-DD');
  const momentEnd = moment(`${endDate.y}-${endDate.m}-${endDate.d}`, 'YYYY-MM-DD');
  const friendlyStartDate = momentStart.format('ddd, MMM D, YYYY');
  const friendlyEndDate = momentEnd.format('ddd, MMM D, YYYY');
  const endsDifferentDay = friendlyStartDate !== friendlyEndDate;

  return (
    <div className="EventDetailCard flex">
      <div className="flex column">
        <ListingImage
          imgId={listingImageExternalId}
          ratio={1.689}
          widths={[545]}
          defaultWidth={545}
          defaultHeight={454}
          style="img-responsive"
          sizes="50vw"
          alt="Peerspace"
        />
      </div>
      <div className="flex column center">
        <h5>{guestFirstName}’s Event</h5>
        <p className="margin-md-bottom">{friendlyStartDate}{ endsDifferentDay && ' -'}</p>
        {
          endsDifferentDay &&
            <p className="margin-md-bottom">{friendlyEndDate}</p>
        }
      </div>
    </div>
  );
};

EventDetailCard.propTypes = {
  isFetching: PropTypes.bool
};

export default EventDetailCard;
